import type { AuditLog } from '@/types/models';

let logCounter = 1;

export let MOCK_ACTIVITY_LOG: AuditLog[] = [
  {
    id: 'log1', entity_type: 'work_order', entity_id: 'wo1', user_id: 'op1', user_name: 'Operator 1',
    action: 'work_order_created', details: 'Work order WO-2026-001 created for Acme Corp',
    timestamp: '2026-03-01T10:00:00Z',
  },
  {
    id: 'log2', entity_type: 'asset', entity_id: 'a1', user_id: 'op1', user_name: 'Operator 1',
    action: 'item_created', details: 'Asset ET000001 created (Laptops - Dell Latitude 5540)',
    timestamp: '2026-03-06T14:30:00Z',
  },
  {
    id: 'log3', entity_type: 'asset', entity_id: 'a2', user_id: 'op1', user_name: 'Operator 1',
    action: 'item_created', details: 'Asset ET000002 created (Desktops - HP ProDesk 400 G7)',
    timestamp: '2026-03-06T14:45:00Z',
  },
  {
    id: 'log4', entity_type: 'asset', entity_id: 'a2', user_id: 'op1', user_name: 'Operator 1',
    action: 'status_changed', details: 'Status changed from received to triaged',
    timestamp: '2026-03-06T15:00:00Z',
  },
  {
    id: 'log5', entity_type: 'asset', entity_id: 'a1', user_id: 'op2', user_name: 'Operator 2',
    action: 'condition_updated', details: 'Condition changed from like_new to good',
    timestamp: '2026-03-06T15:30:00Z',
  },
  {
    id: 'log6', entity_type: 'work_order', entity_id: 'wo3', user_id: 'op1', user_name: 'Operator 1',
    action: 'work_order_completed', details: 'Work order WO-2026-003 marked as completed',
    timestamp: '2026-03-02T16:00:00Z',
  },
];

export function addActivityLogEntry(entry: Omit<AuditLog, 'id' | 'timestamp'>): AuditLog {
  logCounter++;
  const log: AuditLog = {
    ...entry,
    id: `log${logCounter + 10}`,
    timestamp: new Date().toISOString(),
  };
  MOCK_ACTIVITY_LOG = [log, ...MOCK_ACTIVITY_LOG];
  return log;
}

export function getActivityForEntity(entityType: AuditLog['entity_type'], entityId: string): AuditLog[] {
  return MOCK_ACTIVITY_LOG.filter(
    (l) => l.entity_type === entityType && l.entity_id === entityId
  ).sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
}

export function getActivityForWorkOrder(workOrderId: string): AuditLog[] {
  // Get WO logs + asset logs for assets belonging to this WO
  return MOCK_ACTIVITY_LOG.filter(
    (l) =>
      (l.entity_type === 'work_order' && l.entity_id === workOrderId)
  ).sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
}

const ACTION_LABELS: Record<string, { label: string; icon: string }> = {
  item_created: { label: 'Item Created', icon: '📦' },
  status_changed: { label: 'Status Changed', icon: '🔄' },
  condition_updated: { label: 'Condition Updated', icon: '🏷️' },
  item_sold: { label: 'Item Sold', icon: '💰' },
  item_recycled: { label: 'Item Recycled', icon: '♻️' },
  work_order_created: { label: 'Work Order Created', icon: '📋' },
  work_order_completed: { label: 'Work Order Completed', icon: '✅' },
  signature_captured: { label: 'Signature Captured', icon: '✍️' },
  destruction_recorded: { label: 'Destruction Recorded', icon: '🔒' },
};

export function getActionLabel(action: string): { label: string; icon: string } {
  return ACTION_LABELS[action] || { label: action, icon: '📝' };
}
